import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

export function getReleaseImagesResourceQueryOptions(
  releaseId: string,
  options?: { enabled?: boolean },
) {
  return deferredResourceQueryOptions(
    orpc.music.getReleaseImagesResource.queryOptions({
      input: { id: releaseId },
      enabled: options?.enabled,
    }),
  );
}
